// import './App.css';
import Home from './components/Home';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from './components/PrivacyPolicy';
import KidsAdvertisingPolicy from './components/KidsAdvertisingPolicy';

function App() {
  return (
    <Router>
    <Navbar/>
    <Routes>
      <Route exact path='/' element={<Home/>}/>
      <Route exact path='/privacy-policy' element={<PrivacyPolicy/>}/>
      <Route exact path='/kids-advertise-policy' element={<KidsAdvertisingPolicy/>}/>
    </Routes>
    {/* <Home/> */}
    {/* <PrivacyPolicy/>   */}
    </Router>
  );
}

export default App;
